<nav class="admin-nav">
  <div class="nav-inner">

    <!-- Brand -->
    <a class="nav-brand" routerLink="/statistics">
      <img src="/assets/imagotipo.png" alt="BarBook" class="nav-logo" />
      <span class="nav-brand-badge">Admin</span>
    </a>

    <!-- Nav links -->
    <ul class="nav-links">
      @for (item of navItems; track item.path) {
        <li>
          <a
            class="nav-link"
            [routerLink]="item.path"
            routerLinkActive="nav-link--active"
          >
            <!-- Chart icon -->
            @if (item.icon === 'chart') {
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="20" x2="18" y2="10"/>
                <line x1="12" y1="20" x2="12" y2="4"/>
                <line x1="6"  y1="20" x2="6"  y2="14"/>
              </svg>
            }
            <!-- Bell icon -->
            @if (item.icon === 'bell') {
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
              </svg>
            }
            <!-- Users icon -->
            @if (item.icon === 'users') {
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
              </svg>
            }
            <span>{{ item.label }}</span>
          </a>
        </li>
      }
    </ul>

    <!-- Right side: logout -->
    <button class="btn-logout" (click)="logout()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
        <polyline points="16 17 21 12 16 7"/>
        <line x1="21" y1="12" x2="9" y2="12"/>
      </svg>
      <span>Cerrar sesión</span>
    </button>

  </div>
</nav>
